import IconButton from './IconButton.view';

export default IconButton;
